import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = ({ authenticated, currentUser, isAdmin, onLogout, activeNav }) => {
  // Function to generate gradient avatar background based on user name
  const generateAvatarColor = (name) => {
    const colors = [
      'linear-gradient(135deg, #3498db, #1abc9c)', // blue-green
      'linear-gradient(135deg, #9b59b6, #f39c12)', // purple-orange
      'linear-gradient(135deg, #e74c3c, #f39c12)', // red-orange
      'linear-gradient(135deg, #2ecc71, #3498db)', // green-blue
      'linear-gradient(135deg, #f1c40f, #e67e22)'  // yellow-orange
    ];
    
    // Generate a simple hash for the name to pick a consistent color
    const hash = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return colors[hash % colors.length];
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark" style={{ 
      background: 'linear-gradient(to right, #2c3e50, #1a252f)',
      padding: '10px 20px',
      boxShadow: '0 3px 10px rgba(0, 0, 0, 0.2)'
    }}>
      <div className="container-fluid">
        <Link to="/dashboard" className="navbar-brand d-flex align-items-center">
          <i className="fas fa-laptop-medical" style={{ 
            marginRight: '12px', 
            fontSize: '24px',
            filter: 'drop-shadow(0 2px 3px rgba(0, 0, 0, 0.2))'
          }}></i>
          <span style={{ 
            fontWeight: '700', 
            letterSpacing: '0.5px',
            fontSize: '1.2rem'
          }}>Kipu ICD Service</span>
        </Link>
        
        {authenticated && (
          <>
            <button 
              className="navbar-toggler" 
              type="button" 
              data-bs-toggle="collapse" 
              data-bs-target="#navbarContent"
              aria-controls="navbarContent" 
              aria-expanded="false" 
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            
            <div className="collapse navbar-collapse" id="navbarContent">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item px-1">
                  <Link 
                    to="/dashboard" 
                    className={`nav-link ${activeNav === 'dashboard' ? 'active' : ''}`}
                    style={{
                      borderRadius: '4px',
                      padding: '8px 12px',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <i className="fas fa-chart-line me-2"></i> Dashboard
                  </Link>
                </li>
                <li className="nav-item px-1">
                  <Link 
                    to="/search" 
                    className={`nav-link ${activeNav === 'icd-search' ? 'active' : ''}`}
                    style={{
                      borderRadius: '4px',
                      padding: '8px 12px',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <i className="fas fa-search me-2"></i> Search Codes
                  </Link>
                </li>
                <li className="nav-item px-1">
                  <Link 
                    to="/categories" 
                    className={`nav-link ${activeNav === 'icd-categories' ? 'active' : ''}`}
                    style={{
                      borderRadius: '4px',
                      padding: '8px 12px',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <i className="fas fa-folder-open me-2"></i> Code Categories
                  </Link>
                </li>
                {isAdmin && (
                  <li className="nav-item px-1">
                    <Link
                      to="/admin" 
                      className={`nav-link ${activeNav === 'admin-tools' ? 'active' : ''}`}
                      style={{
                        borderRadius: '4px',
                        padding: '8px 12px',
                        transition: 'all 0.2s ease',
                        ...(activeNav === 'admin-tools' ? {
                          background: 'rgba(255, 255, 255, 0.1)'
                        } : {})
                      }}
                    >
                      <i className="fas fa-tools me-2"></i> Admin Tools
                    </Link>
                  </li>
                )}
              </ul>
              
              <div className="d-flex align-items-center">
                {authenticated && currentUser && (
                  <>
                    <div className="nav-item dropdown">
                      <a 
                        className="nav-link dropdown-toggle d-flex align-items-center" 
                        href="#" 
                        id="userDropdown" 
                        role="button" 
                        data-bs-toggle="dropdown" 
                        aria-haspopup="true" 
                        aria-expanded="false"
                        style={{
                          borderRadius: '50px',
                          padding: '6px 14px 6px 6px',
                          background: 'rgba(255, 255, 255, 0.1)',
                          backdropFilter: 'blur(10px)',
                          border: '1px solid rgba(255, 255, 255, 0.1)',
                          transition: 'all 0.2s ease',
                          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
                        }}
                      >
                        <div 
                          className="rounded-circle d-flex align-items-center justify-content-center me-2" 
                          style={{ 
                            width: '38px', 
                            height: '38px', 
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: 'white',
                            background: generateAvatarColor(currentUser.name),
                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                            border: '2px solid rgba(255, 255, 255, 0.8)'
                          }}
                        >
                          {currentUser.name.charAt(0).toUpperCase()}
                        </div>
                        <span style={{ fontWeight: '500' }}>{currentUser.name}</span>
                        {isAdmin && (
                          <span className="badge bg-danger ms-2 text-white" style={{ 
                            fontSize: '0.7rem', 
                            padding: '0.35em 0.65em',
                            fontWeight: '600'
                          }}>Admin</span>
                        )}
                      </a>
                      <div 
                        className="dropdown-menu dropdown-menu-end" 
                        aria-labelledby="userDropdown"
                        style={{
                          borderRadius: '8px',
                          border: '1px solid rgba(0, 0, 0, 0.1)',
                          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                          padding: '10px 0',
                          marginTop: '10px'
                        }}
                      >
                        <div className="dropdown-item-text px-4 py-2">
                          <small className="text-muted d-block">Signed in as</small>
                          <strong style={{ overflowWrap: 'break-word', maxWidth: '200px', display: 'block' }}>{currentUser.email}</strong>
                        </div>
                        <div className="dropdown-divider"></div>
                        <a 
                          className="dropdown-item px-4 py-2" 
                          href="#" 
                          onClick={onLogout}
                          style={{ color: '#e74c3c' }}
                        >
                          <i className="fas fa-sign-out-alt me-2"></i> Sign Out
                        </a>
                      </div>
                    </div>
                  </>
                )}
                
                {!authenticated && (
                  <span className="badge bg-warning py-2 px-3" style={{ fontSize: '0.9rem' }}>
                    <i className="fas fa-user-lock me-2"></i> Not authenticated
                  </span>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 
